// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === 391) return "static/css/391.d09ed346.css";
  // return url for filenames based on template
  return "" + chunkId + ".css"
}